// extracted by mini-css-extract-plugin
export default {"mainContainer":"OptionButton_mainContainer__Sxjd3","details":"OptionButton_details__eBK2j","price":"OptionButton_price__2ileb"};